import { useInterstitialAdGuard } from './useInterstitialAdGuard';

export function InterstitialAdGuard() {
  useInterstitialAdGuard();
  return null;
}
